import { render } from "./CredentialsList.vue?vue&type=template&id=be8bf06a&scoped=true"
import script from "./CredentialsList.vue?vue&type=script&lang=js"
export * from "./CredentialsList.vue?vue&type=script&lang=js"

import "./CredentialsList.vue?vue&type=style&index=0&id=be8bf06a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be8bf06a"]])

export default __exports__